module.exports = __webpack_public_path__ + "static/media/ic_head5.464178a3.png";